import { createSelector } from 'reselect';

export const assumptionsStateSelector = state => state.Assumptions;

export const assumptionsSelector = createSelector(
  assumptionsStateSelector,
  ({ Assumptions }) => Assumptions,
);

export const correlationMatrixSelector = createSelector(
  assumptionsStateSelector,
  ({ CorrelationMatrix }) => CorrelationMatrix,
);
